/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneList from 'sites/allas/components/standalone/List';

export const DynamicStandaloneList = StandaloneList;
export type DynamicStandaloneListProps = PropsFromComponent<typeof StandaloneList>;

export const DynamicStandaloneListWith = (extras: DynamicStandaloneExtras): typeof StandaloneList => {
    return function DynamicStandaloneList(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'List');
        return <StandaloneList {...mergeProps({ options: { theme } }, props)} />;
    }
}